module.exports = __webpack_public_path__ + "img/clothing188.12ca0792.jpg";